export default __webpack_public_path__ + "static/media/nichesImg.17ec7675.png";